const handleAcceptsMarketing = () => {
    console.log('ran handleAcceptsMarketing');

    $('#accepts_marketing.account_marketing').on('click', function () {
        console.log('clicked accepts marketing');
    });
}

const delay = (delayInms) => {
  return new Promise(resolve => setTimeout(resolve, delayInms));
};

// Runs on DOMReady, runs on each page load
document.addEventListener("DOMContentLoaded", async function () {
    try {
        let i = 0;

        while (!window.$) {
            await delay(100);
            i++;
        }

        handleAcceptsMarketing();
    } catch (err) {
        console.error('error caught in custom.js domready, error: ', err);
    }
});